module.exports = __webpack_public_path__ + "img/statistic.aff0bc43.svg";